function createProperty(objToUpdate, path, value) {
  const fields = path.split(".");
  const lastKey = fields.pop();
  if (!lastKey) {
    throw new Error(`[createProperty] The path provided is empty. At least two are required.`);
  }
  if (fields.length === 0) {
    throw new Error(`[createProperty] The path provided (${path}) is made of a single step. At least two are required.`);
  }
  let nextState = objToUpdate;
  for (const field of fields) {
    nextState[field] ??= {};
    nextState = nextState[field];
  }
  nextState[lastKey] = value;
  return objToUpdate;
}
export {
  createProperty
};
//# sourceMappingURL=createProperty.js.map
